import { render, staticRenderFns } from "./MyPackages.vue?vue&type=template&id=1064f5d2&"
import script from "./MyPackages.vue?vue&type=script&lang=js&"
export * from "./MyPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports